import React from 'react';
import { WrappedButton, WrappedButtonType } from '../../../ui/button';
import InlineMessage from '../../../ui/panel/InlineMessage.component';

type FedExResellerMessageProps = {
	readonly onClose: () => void;
	readonly onAddFedExClick: () => void;
};

export function FedExResellerMessage({
	onClose,
	onAddFedExClick,
}: FedExResellerMessageProps) {
	return (
		<div className="banner-container">
			<InlineMessage
				type="information"
				header="FedEx Services Now Available"
				text="Start shipping with FedEx services at discounted rates right away!"
				canClose={true}
				actions={
					<WrappedButton
						label="Add FedEx"
						buttonType={WrappedButtonType.TertiaryWhite}
						dataqa="fedex-reseller-connect-message-add-button"
						onClick={onAddFedExClick}
					/>
				}
				dataqa="fedex-reseller-connect-message"
				onClose={onClose}
			></InlineMessage>
		</div>
	);
}
